module.exports = __webpack_public_path__ + "media/images/sp/visit_reserve/flow-reserve-449134029336ed2ee9cc4e867c1dd1c5.png";